import { WireToInformationFieldId } from '../../Content.constants';

export const CLEARED_LOCATION_FIELDS = {
  feeProviderLocationId: null,
  companyStreet: '',
  companyCity: '',
  companyState: '',
  companyZipCode: '',
  [WireToInformationFieldId.BANK]: '',
  city: '',
  state: '',
  [WireToInformationFieldId.ABA_NUMBER]: '',
  [WireToInformationFieldId.ACCOUNT_NUMBER]: '',
  [WireToInformationFieldId.FEE_PROVIDER_ADDRESS]: '',
  [WireToInformationFieldId.CITY]: '',
  [WireToInformationFieldId.STATE]: '',
};

export const ADVANCE_AMOUNT_FIELDS = new Set([
  WireToInformationFieldId.WIRE_AMOUNT,
  WireToInformationFieldId.ADVANCE_AMOUNT,
  WireToInformationFieldId.ADD_ADVANCE_AMOUNT,
]);
